module.exports = __webpack_public_path__ + "static/img/bg.a31dfbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-bluetooth/bg.png
// module id = roAf
// module chunks = 215